import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setFluidsState } from '../store/fluids.actions'

export function* getFluids(pcrDoc: IPcr) {
  const { fluids } = pcrDoc
  if (fluids && Object.keys(fluids).length !== 0) {
    yield put(setFluidsState(fluids))
  }
}
